import { GET_PROJECT, GET_PUBLIC_PROJECT } from '../../fetchTypes';
import {
  createDefaultRequestInitialState,
  createSelectorById,
  createSelectorByIdList,
  defaultRequestByIdReducer,
} from './withFetch';

const initialState = createDefaultRequestInitialState();
export const actionDataToId = (data) => data.projectId;

const reducer = defaultRequestByIdReducer({
  actionDataToId,
  resultMapper: (data) =>
   (data || {}).response || {},
});

export default (state = initialState, action) => {
  switch (action.fetchType) {
    case GET_PROJECT:
      return reducer(state, action);
    case GET_PUBLIC_PROJECT:
      return reducer(state, action);
    default:
      return state;
  }
};

const selfSelector = (state) => state.fetcher.project;
export const selectFetcherProject = selfSelector;
export const selectProjectByProjectId = createSelectorById(selfSelector);
export const selectProjectListByProjectIdList =
  createSelectorByIdList(selfSelector);
